module.exports = __webpack_public_path__ + "img/j5r.6fab44d3.png";